import { THeadingTag } from '../types/types';

/**
 * Returns following tag in H-tags hierarchy.
 * If H1 is passed to function in currentPage property than H2 is returned.
 * In case currentTag is H6 then DIV tag is returned.
 * */
export const getFollowingHTag = (currentTag: THeadingTag): THeadingTag => {
  const tags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div'] as Array<THeadingTag>;

  if (typeof currentTag === 'string') {
    const indexOfCurrentTag = tags.indexOf(currentTag);

    if (indexOfCurrentTag >= 0 && indexOfCurrentTag < 6) {
      return tags[indexOfCurrentTag + 1];
    }
  }

  return 'div';
};
